module.exports = __webpack_public_path__ + "static/media/broed.37e3297e.mp3";